var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "70mm",
    height: "84mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 7000 8400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5253 1333l-5009 0 -218 0 0 218 0 6600 0 218 218 0 5009 0 218 0 0 -218 0 -6600 0 -218 -218 0zm-1738 4443l-2371 0 0 434 2371 0 0 -434zm803 -1051l-3174 0 0 433 3174 0 0 -433zm0 -1052l-3174 -1 0 434 3174 0 0 -433zm2220 -3470l-5009 0 -218 0 0 217 0 217 4932 0 78 0 0 78 0 6523 217 0 218 0 0 -218 0 -6600 0 -217 -218 0zm-5998 1566l4417 0 78 0 0 78 0 6008 0 78 -78 0 -4417 0 -79 0 0 -78 0 -6008 0 -78 79 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.5ada3d817e7122fcbf75a4343792fbd5.svg";
export { ForwardRef as ReactComponent };